/* eslint-disable */

export default {
  created: function () {
  },
  methods: {
    isNullOrEmpty(s) {
      return s == null || s.trim().length == 0;
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/StringMixin.js